import { RevealBlock } from "./motion";
import { Boxes, Radio, Wrench } from "lucide-react";

const IMG = "/machine.png";

const POINTS = [
  { icon: Boxes,  t: "Compact, site-ready footprint",     d: "A sleek TCN-ELV-11G unit configured for terminal and high-traffic retail settings, subject to site approval." },
  { icon: Radio,  t: "Remote inventory and monitoring",   d: "Live stock, uptime and performance visibility to support reliable service." },
  { icon: Wrench, t: "Fully managed replenishment",       d: "Restocking and servicing handled end-to-end by our team." },
];

export default function Concept() {
  return (
    <section id="concept" className="relative bg-cream text-ink py-16 md:py-24" data-testid="concept-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-12 items-center">
        {/* Machine image */}
        <RevealBlock className="col-span-12 md:col-span-6 order-2 md:order-1" y={30}>
          <div className="relative aspect-[4/5] md:aspect-[4/5] w-full overflow-hidden rounded-2xl border border-ink/10 bg-cream2 shadow-[0_10px_40px_rgba(10,30,68,0.10)]">
            <img
              src={IMG}
              alt="MinisRus TCN-ELV-11G automated retail machine in a modern high-traffic location"
              className="absolute inset-0 w-full h-full object-cover"
              data-testid="concept-image"
            />
          </div>
        </RevealBlock>

        {/* Copy + points */}
        <div className="col-span-12 md:col-span-6 order-1 md:order-2">
          <RevealBlock>
            <p className="eyebrow mb-3">The Concept</p>
            <h2 className="font-display font-light text-ink text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Modern automated retail,<br />
              <span className="text-orange">carefully curated.</span>
            </h2>
            <div className="mt-5 gold-rule" />
            <p className="mt-6 max-w-xl text-ink/75 text-base md:text-lg leading-relaxed font-sans">
              MinisRus turns compact, high-footfall spaces into convenient retail touchpoints. Each cashless unit can be tailored to its terminal zone, passenger profile and approved product mix — with day-to-day operation managed by our team.
            </p>
          </RevealBlock>

          <div className="mt-10 grid gap-6">
            {POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <RevealBlock key={p.t} delay={i * 0.08} y={20} className="flex items-start gap-5" data-testid={`concept-point-${i}`}>
                  <div className="shrink-0 w-12 h-12 rounded-full bg-orange/15 flex items-center justify-center">
                    <Icon size={20} strokeWidth={1.7} className="text-orange-deep" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-ink text-lg">{p.t}</h3>
                    <p className="mt-1 text-ink/65 text-sm md:text-base leading-relaxed max-w-md">{p.d}</p>
                  </div>
                </RevealBlock>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
